import script from "./CallTopBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallTopBar.vue?vue&type=script&setup=true&lang=ts"

import "./CallTopBar.vue?vue&type=style&index=0&id=39c3bed0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c3bed0"]])

export default __exports__